// JWT Decoder Tool — decode (not verify) a JSON Web Token.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const jwtDecoderTool: Tool = {
  id: "jwt-decoder",
  name: () => m.jw_tool_name(),
  description: () => m.jw_tool_description(),
  icon: "🔓",
  basePath: "/jwt-decoder",
  status: "stable",
  tags: ["jwt", "token", "decode", "developer"],
  pages: [
    {
      name: () => m.jw_nav_main(),
      path: "/jwt-decoder",
      description: () => m.jw_nav_main_desc(),
      icon: "🔓",
    },
  ],
};
